import { compose } from '@doltech/utils/lib/compose';

import { withDolEditorStore } from '../../DolEditor/dol-editor.store';

export const withStoreRequiredForOnlineTestEditor = () => {
  return compose(withDolEditorStore);
};
